import { mineMixin } from "@mixin/mine";
export default {
  name: "pageMine",
  mixins: [mineMixin]
};